<script>
    import { Toaster } from "$lib/components/ui/sonner";
    import { User } from "$lib/User";
    import { ModeWatcher } from "mode-watcher";

    import "../app.css";

    import { onMount } from "svelte";

    onMount(async () => {
        // Setting timezone
        document.cookie = `django_timezone=${
            Intl.DateTimeFormat().resolvedOptions().timeZone
        };SameSite=Strict`;

        const user = await User.load();

        /********/
        // hotjar tracking
        (function (h, o, t, j, a, r) {
            h.hj =
                h.hj ||
                function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                };
            h._hjSettings = { hjid: 3105017, hjsv: 6 };
            a = o.getElementsByTagName("head")[0];
            r = o.createElement("script");
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

        /* Tawk.to */
        var Tawk_API = Tawk_API || {};
        Tawk_API.visitor = { name: user.name, email: user.email };
        (function () {
            var s1 = document.createElement("script"),
                s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = "https://embed.tawk.to/64431d8c31ebfa0fe7f9b7ac/1guj2mrao";
            s1.charset = "UTF-8";
            s1.setAttribute("crossorigin", "*");
            s0.parentNode.insertBefore(s1, s0);
        })();
    });
</script>

<Toaster />

<ModeWatcher />

<slot />
